import React, { useState } from 'react';

const AIQuizGenerator = ({ onQuestionsGenerated, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState({
    subject: 'Math',
    class: '5',
    topic: '',
    count: 5
  });

  const generateQuestions = async () => {
    setLoading(true);
    try {
      // Minimal AI prompt - very short to reduce tokens
      const prompt = `${config.count} MCQ for Class ${config.class} ${config.subject} ${config.topic}. Format: Q|A|B|C|D|correct`;
      
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/ai/generate-quiz`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt, config })
      });

      if (response.ok) {
        const questions = await response.json();
        onQuestionsGenerated(questions);
        onClose();
      } else {
        alert('Failed to generate questions');
      }
    } catch (error) {
      console.error('AI generation error:', error);
      alert('Error generating questions');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="quiz-game">
      <div className="prize-ladder-container" style={{ maxWidth: '400px' }}>
        <h3>🤖 AI Quiz Generator</h3>
        
        <div style={{ marginBottom: '15px' }}>
          <label>Subject:</label>
          <select 
            value={config.subject} 
            onChange={(e) => setConfig({...config, subject: e.target.value})}
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          >
            <option value="Math">Math</option>
            <option value="Science">Science</option>
            <option value="English">English</option>
            <option value="History">History</option>
          </select>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Class:</label>
          <select 
            value={config.class} 
            onChange={(e) => setConfig({...config, class: e.target.value})}
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          >
            {[1,2,3,4,5,6,7,8,9,10].map(c => (
              <option key={c} value={c}>Class {c}</option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Topic:</label>
          <input 
            type="text"
            value={config.topic}
            onChange={(e) => setConfig({...config, topic: e.target.value})}
            placeholder="e.g. Addition, Fractions"
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label>Questions:</label>
          <select 
            value={config.count} 
            onChange={(e) => setConfig({...config, count: parseInt(e.target.value)})}
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          >
            <option value={3}>3 Questions</option>
            <option value={5}>5 Questions</option>
            <option value={10}>10 Questions</option>
          </select>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button 
            onClick={generateQuestions}
            disabled={loading || !config.topic}
            className="continue-btn"
            style={{ flex: 1 }}
          >
            {loading ? '🤖 Generating...' : '✨ Generate Quiz'}
          </button>
          <button onClick={onClose} className="quit-btn">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AIQuizGenerator;